import {
    Column,
    Container,
    Image,
    Panel9Slice,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';
import {Localization} from '../../utils/Localization.js';
import {ShoppeBase} from './shoppe-base.js';
import {MenuPanels} from '../../models/UIModel.js';
import {goToGame} from '../utils/goToGame.js';
import {
    Align,
    FlexDirection,
    Justify,
    PositionType,
    TextProps,
} from '@wonderlandengine/react-ui';
import {Texture} from '@wonderlandengine/api';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {use, useEffect, useMemo, useState} from 'react';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {FlatOpaqueTextured} from '../../types/materials.js';
import {formatString, parseColor} from '../utils/utils.js';
import {colorSwatch} from '../utils/colorSwatch.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {Statistics} from '../../components/statistics.js';
import {loop, stop} from '../utils/animation-context.js';
import {Easing, lerpArr} from '../../utils/lerp.js';
import {useAnimation} from '../hooks/useAnimation.js';
import {goToPowerupStorePopup} from '../utils/goToPowerupStorePopup.js';
import {StoreInventoryItems} from '../../enums/StoreInventoryItems.js';
import {goToPreviousMenu} from '../utils/goToPreviousMenu.js';
import {PowerupMaterialType, usePowerupMaterial} from '../hooks/usePowerupMaterial.js';

const PerksButton = (
    props: React.PropsWithChildren<TextProps> & {
        icon: Texture;
        title: string;
        storeItem: StoreInventoryItems;
        upgradeLevelStat: TransactionalNames;
        isComingSoon?: boolean;
    }
) => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;
    const baseMaterial = rotbMats?.buttonMaterial as FlatOpaqueTextured;
    const shadowMaterial = rotbMats?.buttonShadowMaterial;

    const defaultButtonMaterial = usePowerupMaterial(
        PowerupMaterialType.Default,
        baseMaterial,
        colorSwatch.PowerupPerksButton
    );

    const runOutMaterial = usePowerupMaterial(
        PowerupMaterialType.RunOut,
        baseMaterial,
        colorSwatch.PowerupPerksButtonRefill1
    );
    const comingSoonMaterial = usePowerupMaterial(
        PowerupMaterialType.ComingSoon,
        baseMaterial,
        colorSwatch.GenericButton
    );

    const lockedMaterial = usePowerupMaterial(
        PowerupMaterialType.Locked,
        baseMaterial,
        colorSwatch.PowerupPerksButtonLocked
    );

    const divotEmpty = usePowerupMaterial(
        PowerupMaterialType.DivotEmpty,
        baseMaterial,
        colorSwatch.UpgradeDivotEmpty
    );

    const divotFull = usePowerupMaterial(
        PowerupMaterialType.DivotFull,
        baseMaterial,
        colorSwatch.UpgradeDivotFull
    );

    const currentUpgradeLevel = Statistics.instance.getTransactional(
        props.upgradeLevelStat
    );

    const isLocked = Statistics.instance.getTransactional(props.upgradeLevelStat) === 0;

    const divots = [];

    for (let i = 0; i < 5; i++) {
        if (i < currentUpgradeLevel) {
            divots.push(true);
        } else {
            divots.push(false);
        }
    }

    const [buttonMaterial, setButtonMaterial] = useState(() => {
        if (props.isComingSoon) {
            return comingSoonMaterial;
        }
        if (isLocked) {
            return lockedMaterial;
        }
        return defaultButtonMaterial;
    });

    const onClickPerk = () => {
        if (props.isComingSoon) {
            return;
        }
        goToPowerupStorePopup(props.storeItem, true, props.icon);
    };

    return (
        <Container>
            <Container
                left={4}
                top={6}
                onClick={() => {
                    onClickPerk();
                }}
            >
                <Panel9Slice
                    // ref={ref}
                    borderSize={8}
                    borderTextureSize={0.0625}
                    material={shadowMaterial}
                >
                    <Panel9Slice
                        height={108}
                        width={500}
                        paddingLeft={props.text || props.children ? 12 : 0}
                        left={-4}
                        top={-6}
                        material={buttonMaterial}
                        borderSize={8}
                        borderTextureSize={0.0625}
                        flexDirection={FlexDirection.Row}
                        alignItems={Align.Center}
                        alignContent={Align.Stretch}
                        justifyContent={Justify.SpaceBetween}
                    >
                        <Row
                            margin={20}
                            width={460}
                            alignItems={Align.Center}
                            justifyContent={Justify.Center}
                        >
                            <Column gap={2} alignItems={Align.Center}>
                                <Image
                                    height={70}
                                    width={70}
                                    rounding={0}
                                    src={
                                        isLocked && !props.isComingSoon
                                            ? UiTexturesManager.instance.buttonLock
                                            : props.icon
                                    }
                                ></Image>
                                <Row gap={3}>
                                    {!isLocked &&
                                        divots.map((divot, index) => {
                                            return (
                                                <Panel9Slice
                                                    key={index}
                                                    height={12}
                                                    width={12}
                                                    rounding={0}
                                                    border={2}
                                                    borderTextureSize={0.0625}
                                                    material={
                                                        divot ? divotFull : divotEmpty
                                                    }
                                                ></Panel9Slice>
                                            );
                                        })}
                                </Row>
                            </Column>

                            <Column
                                flexGrow={1}
                                alignItems={Align.Center}
                                justifyContent={Justify.Center}
                                gap={20}
                            >
                                <Text
                                    //  top={4}
                                    textAlign={'center'}
                                    flexGrow={1}
                                    // top={-(props.fontSize ?? 32) / 2}
                                    fontSize={28}
                                    text={props.title}
                                ></Text>

                                <Text
                                    //  top={4}
                                    textAlign={'center'}
                                    flexGrow={1}
                                    // top={-(props.fontSize ?? 32) / 2}
                                    fontSize={20}
                                    text={
                                        props.isComingSoon
                                            ? Localization.instance.get('ComingSoon')
                                            : isLocked
                                              ? Localization.instance.get('UnlockNow')
                                              : formatString(
                                                    Localization.instance.get(
                                                        'UpgradeLevel'
                                                    ),
                                                    currentUpgradeLevel
                                                )
                                    }
                                ></Text>
                            </Column>
                        </Row>
                        {props.isComingSoon && (
                            <Image
                                alignSelf={Align.FlexEnd}
                                position={PositionType.Absolute}
                                right={0}
                                width={100}
                                height={100}
                                rounding={5}
                                margin={10}
                                src={UiTexturesManager.instance.comingSoonBanner}
                            ></Image>
                        )}
                    </Panel9Slice>
                </Panel9Slice>
            </Container>
        </Container>
    );
};

export const LoadoutPerks = () => {
    return (
        <ShoppeBase
            title={Localization.instance.get('Perks')}
            onOkay={() => goToPreviousMenu(MenuPanels.Loadout2)}
        >
            <Column
                marginTop={20}
                height={560}
                justifyContent={Justify.SpaceBetween}
                alignItems={Align.Center}
            >
                <PerksButton
                    isComingSoon={true}
                    storeItem={StoreInventoryItems.starBoosterPerk}
                    title={Localization.instance.get('CountdownStarBonus')}
                    icon={UiTexturesManager.instance.starBooster}
                    upgradeLevelStat={TransactionalNames.AddBonusCountdownPerk}
                ></PerksButton>
                <PerksButton
                    storeItem={StoreInventoryItems.rainbowPerk}
                    title={Localization.instance.get('RainbowFruitDescription')}
                    icon={UiTexturesManager.instance.rainbowFruit}
                    upgradeLevelStat={TransactionalNames.RainbowFruitIncreaseUpgrade}
                ></PerksButton>
                <PerksButton
                    storeItem={StoreInventoryItems.tntPerk}
                    title={Localization.instance.get('TNTBlobs')}
                    icon={UiTexturesManager.instance.tntBlob}
                    upgradeLevelStat={TransactionalNames.TNTUpgrade}
                ></PerksButton>
                <PerksButton
                    storeItem={StoreInventoryItems.chainBonusPerk}
                    title={Localization.instance.get('ChainBonus')}
                    icon={UiTexturesManager.instance.comboChainBonus}
                    upgradeLevelStat={TransactionalNames.ComboChainUpgrade}
                ></PerksButton>
                <PerksButton
                    isComingSoon={true}
                    storeItem={StoreInventoryItems.cherryBonusPerk}
                    title={Localization.instance.get('ScoreMultiplier')}
                    icon={UiTexturesManager.instance.scoreModifier}
                    upgradeLevelStat={TransactionalNames.ScoreMultiplierUpgrade}
                ></PerksButton>
            </Column>
        </ShoppeBase>
    );
};
